import React, { useCallback, useContext, useState, useEffect } from 'react';
import Scrollbars from 'react-custom-scrollbars';
import message from 'antd/lib/message';
import { getAxiosTokenInstance } from '../../../utils/axiosInstance';
import { FirebaseContext } from '../../../context/FirebaseContext';
import Button from '../../../NecttosComp/Button/Button';
import { Body, Header, Main } from '../../../NecttosComp/Layout/Layout';
import Input2 from '../../../NecttosComp/Input/Input2';
import { MdDelete } from 'react-icons/md';

function SettupQuestionnaire({ onSuccess, itemData, onCloseModal, questionnaireId, refectOrgin, state, setState }) {
	const { collegeId } = useContext(FirebaseContext);

	useEffect(() => {
		const mainCount = Array(state?.mainQ).fill(1);
		const newState = { ...state };
		let needsUpdate = false;

		mainCount?.forEach((_, i) => {
			if (!newState[i + 'subQ']) {
				newState[i + 'subQ'] = 1;
				needsUpdate = true;
			}
		});

		if (needsUpdate) setState(newState);
	}, [state]);

	const deleteSubQuestion = (mainIndex, subIndex) => {
		const newState = { ...state };
		const subQKey = `${mainIndex}subQ`;
		const totalSubQ = newState[subQKey] || 1;

		if (totalSubQ === 1) return;

		const keys = ['subQuestion', 'type', 'nature', 'option1', 'option2', 'option3', 'option4', 'option5', 'likert1', 'likert5'];
		keys.forEach((k) => delete newState[`${mainIndex}${subIndex}~${k}`]);

		for (let i = subIndex + 1; i < totalSubQ; i++) {
			keys.forEach((k) => {
				newState[`${mainIndex}${i - 1}~${k}`] = newState[`${mainIndex}${i}~${k}`];
				delete newState[`${mainIndex}${i}~${k}`];
			});
		}

		newState[subQKey] = totalSubQ - 1;
		setState(newState);
	};

	const deleteMainQuestion = (deleteIndex) => {
		const newState = { ...state };
		const totalMainQ = newState.mainQ || 1;

		if (totalMainQ <= 1) {
			const subQCount = newState[`${deleteIndex}subQ`] || 1;
			const keysToDelete = [`${deleteIndex}~question`, `${deleteIndex}subQ`];
			for (let i = 0; i < subQCount; i++) {
				const fields = ['subQuestion', 'type', 'nature', 'option1', 'option2', 'option3', 'option4', 'option5', 'likert1', 'likert5'];
				fields.forEach((f) => keysToDelete.push(`${deleteIndex}${i}~${f}`));
			}
			keysToDelete.forEach((key) => delete newState[key]);
			newState[`${deleteIndex}subQ`] = 1;
			setState(newState);
			return;
		}

		const subQCount = newState[`${deleteIndex}subQ`] || 1;
		const keysToDelete = [`${deleteIndex}~question`, `${deleteIndex}subQ`];
		for (let i = 0; i < subQCount; i++) {
			const fields = ['subQuestion', 'type', 'nature', 'option1', 'option2', 'option3', 'option4', 'option5', 'likert1', 'likert5'];
			fields.forEach((f) => keysToDelete.push(`${deleteIndex}${i}~${f}`));
		}
		keysToDelete.forEach((key) => delete newState[key]);

		for (let i = deleteIndex + 1; i < totalMainQ; i++) {
			newState[`${i - 1}~question`] = newState[`${i}~question`];
			newState[`${i - 1}subQ`] = newState[`${i}subQ`] || 1;

			const subQ = newState[`${i}subQ`] || 1;
			for (let j = 0; j < subQ; j++) {
				const fields = ['subQuestion', 'type', 'nature', 'option1', 'option2', 'option3', 'option4', 'option5', 'likert1', 'likert5'];
				fields.forEach((f) => {
					newState[`${i - 1}${j}~${f}`] = newState[`${i}${j}~${f}`];
					delete newState[`${i}${j}~${f}`];
				});
			}

			delete newState[`${i}~question`];
			delete newState[`${i}subQ`];
		}

		newState.mainQ = totalMainQ - 1;
		setState(newState);
	};

	const postQuestionnaire = useCallback(async () => {
		let finalData = [];
		const mainCount = Array(state?.mainQ).fill(1);

		mainCount?.forEach((_, c) => {
			let subQuestions = [];
			Array(state[c + 'subQ'] || 1)
				.fill(1)
				?.forEach((_, i) => {
					const prefix = `${c}${i}~`;
					let subQuestion = state[prefix + 'subQuestion'];
					let type = state[prefix + 'type'];
					let nature = state[prefix + 'nature'];
					let option1 = state[prefix + 'option1'];
					let option2 = state[prefix + 'option2'];
					let option3 = state[prefix + 'option3'];
					let option4 = state[prefix + 'option4'];
					let option5 = state[prefix + 'option5'];
					let likert1 = state[prefix + 'likert1'];
					let likert5 = state[prefix + 'likert5'];

					subQuestions.push({
						subQuestion,
						type,
						nature,
						...(option1 && { option1 }),
						...(option2 && { option2 }),
						...(option3 && { option3 }),
						...(option4 && { option4 }),
						...(option5 && { option5 }),
						...(likert1 && { likert1 }),
						...(likert5 && { likert5 }),
					});
				});
			finalData.push({ question: state[c + '~question'], subQuestions });
		});

		try {
			const instance = await getAxiosTokenInstance();
			const resp = await instance.post('/college/iqac/postQuestionnair', {
				collegeId,
				_id: questionnaireId,
				questionnaire: finalData,
			});
			if (resp.data.statusCode !== 200) throw new Error(resp.data.message || 'API Error');
			message.success('Questionnaire saved successfully');
			onSuccess();
			await refectOrgin();
			setState({ mainQ: 1 });
		} catch (error) {
			await refectOrgin();
			setState({ mainQ: 1 });
			message.error(error?.response?.data?.message || error?.message || 'Failed to save questionnaire');
		}
	}, [state, collegeId, questionnaireId, refectOrgin, onSuccess]);

	const mainCount = Array(state?.mainQ || 1).fill(1);

	return (
		<Main title='Setup Questionnaire' height='100%' width='100%'>
			<Header>
				<div className='w-full flex justify-end gap-4 px-4'>
					<Button type='save' onClick={postQuestionnaire}>
						Save
					</Button>
					<Button type='close' onClick={onCloseModal}>
						Close
					</Button>
				</div>
			</Header>
			<Body height='100%'>
				<Scrollbars className='h-full'>
					<div className='max-w-7xl mx-auto px-4 py-6 space-y-10'>
						{mainCount.map((_, c) => (
							<section key={c} className='bg-[#f9fafb] dark:bg-[#1f2937] border border-[#e5e7eb] dark:border-[#4a4f55] rounded-2xl shadow-md p-4 sm:p-6 space-y-6'>
								<div className='flex justify-between items-center border-b pb-2'>
									<h4 className='text-xl font-bold text-gray-800 dark:text-white'>Main Question {c + 1}</h4>
									<button onClick={() => deleteMainQuestion(c)} className='p-2 bg-[#ef4444] hover:bg-[#dc2626] dark:bg-[#757980] text-white rounded-md shadow-sm'>
										<MdDelete size={26} />
									</button>
								</div>

								<Input2 type='text' fieldName='Main Question*' returnKey={`${c}~question`} state={state} setState={setState} className='w-full bg-[#ffffff] dark:bg-[#323b49] text-[#111827] dark:text-[#e5e7eb]' />

								{Array(state[c + 'subQ'] || 1)
									.fill(1)
									.map((_, i) => (
										<div key={i} className='border p-4 rounded bg-[#f3f4f6] dark:bg-[#2d3748] border-dashed border-[#d1d5db] dark:border-[#4b5563]'>
											<div className='flex justify-between items-center mb-2'>
												<h5 className='text-md font-semibold text-[#1f2937] dark:text-[#e5e7eb]'>Sub Question {i + 1}</h5>
												<button onClick={() => deleteSubQuestion(c, i)} className='p-2 bg-[#ef4444] hover:bg-[#dc2626] dark:bg-[#9d9ea1] text-white rounded-md shadow-sm'>
													<MdDelete size={20} />
												</button>
											</div>

											<div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
												<Input2 type='text' fieldName='Sub Question*' returnKey={`${c}${i}~subQuestion`} state={state} setState={setState} className='w-full bg-[#ffffff] dark:bg-[#374151] text-[#111827] dark:text-[#f9fafb]' />
												<Input2
													type='drop'
													fieldName='Type*'
													returnKey={`${c}${i}~type`}
													state={state}
													setState={setState}
													options={[
														{ label: 'Paragraph', value: 'Paragraph' },
														{ label: 'Options', value: 'Options' },
														{ label: 'Likert Scale', value: 'Likert Scale' },
													]}
													optionDisplay='label'
													optionKey='value'
													className='w-full bg-[#ffffff] dark:bg-[#374151] text-[#111827] dark:text-[#f9fafb]'
												/>
												<Input2
													type='drop'
													fieldName='Nature*'
													returnKey={`${c}${i}~nature`}
													state={state}
													setState={setState}
													options={[
														{ label: 'Mandatory', value: 'Mandatory' },
														{ label: 'Optional', value: 'Optional' },
													]}
													optionDisplay='label'
													optionKey='value'
													className='w-full bg-[#ffffff] dark:bg-[#374151] text-[#111827] dark:text-[#f9fafb]'
												/>
											</div>

											{state[`${c}${i}~type`] === 'Likert Scale' && (
												<div className='grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4'>
													<Input2 type='text' fieldName='Label for Minimum Value (e.g., Strongly Disagree)' returnKey={`${c}${i}~likert1`} state={state} setState={setState} className='w-full text-gray-900 dark:text-gray-100' />
													<Input2 type='text' fieldName='Label for Maximum Value (e.g., Strongly Agree)' returnKey={`${c}${i}~likert5`} state={state} setState={setState} className='w-full text-gray-900 dark:text-gray-100' />
												</div>
											)}

											{state[`${c}${i}~type`] === 'Options' && (
												<div className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 mt-4'>
													{[1, 2, 3, 4, 5].map((n) => (
														<Input2 key={n} type='text' fieldName={`Option ${n}`} returnKey={`${c}${i}~option${n}`} state={state} setState={setState} className='w-full text-[#111827] dark:text-[#f9fafb]' />
													))}
												</div>
											)}

											{i === (state[c + 'subQ'] || 1) - 1 && (
												<div className='pt-4'>
													<Button type='refresh' size='small' onClick={() => setState({ ...state, [c + 'subQ']: (state[c + 'subQ'] || 1) + 1 })} className='text-white rounded-md px-3 py-1 text-sm shadow-sm dark:text-[#f9fafb]'>
														Add Sub Question
													</Button>
												</div>
											)}
										</div>
									))}
							</section>
						))}

						<div className='flex justify-end'>
							<Button type='update' onClick={() => setState({ ...state, mainQ: state.mainQ + 1 })} className='text-lg font-semibold rounded-2xl px-6 py-4 shadow-lg'>
								Add Main Question
							</Button>
						</div>
					</div>
				</Scrollbars>
			</Body>
		</Main>
	);
}

export default SettupQuestionnaire;
